/**
 * Apex-only candidate information routes.
 *
 * Keep these paths in one dependency-light module so navigation, middleware,
 * and sitemaps cannot quietly drift apart.
 */
export const CANDIDATE_PUBLIC_ROUTES = {
  companies: '/companies',
  about: '/about',
  trust: '/trust',
  safety: '/safety',
  help: '/help',
  contact: '/contact',
  careerGuide: '/blog',
  editorialPolicy: '/blog/editorial-policy',
} as const;

export const APEX_STATIC_INFORMATION_PATHS = [
  CANDIDATE_PUBLIC_ROUTES.about,
  CANDIDATE_PUBLIC_ROUTES.trust,
  CANDIDATE_PUBLIC_ROUTES.safety,
  CANDIDATE_PUBLIC_ROUTES.help,
  CANDIDATE_PUBLIC_ROUTES.contact,
  CANDIDATE_PUBLIC_ROUTES.editorialPolicy,
] as const;
